import React, { useContext } from 'react';
import { useFormContext } from 'react-hook-form';
import { useLocation } from 'react-router-dom';

import { NCRContext } from 'views';

import { FormDatePicker } from 'components/form/prototypes';

const CreatedDate = () => {

  const { state } = useContext(NCRContext);
  const { control, register } = useFormContext();
  const location = useLocation();
  var label = "Date NCR Raised"

  const isDisabled = true;

  if (location.pathname === "/create_return" || location.pathname.includes("/return")) {
    label = "Date Return Raised"
  }

  return (
    <FormDatePicker
      label={label}
      name='ncr.created_date'
      control={control}
      register={register}
      selectedDate={new Date(state.ncr.created_date) || new Date()}
      showTime
      disabled={isDisabled}
    />
  )
}

export { CreatedDate };
